import { render, staticRenderFns } from "./ElaboracaoCardapio.vue?vue&type=template&id=34502ee8&scoped=true&"
import script from "./ElaboracaoCardapio.vue?vue&type=script&lang=js&"
export * from "./ElaboracaoCardapio.vue?vue&type=script&lang=js&"
import style0 from "./ElaboracaoCardapio.vue?vue&type=style&index=0&id=34502ee8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34502ee8",
  null
  
)

export default component.exports